import { Navigation, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const Slider = ({ settings, items, sliderPlay }) => {
    const { slidesView } = settings;
    const { isAutoPlay, duration } = sliderPlay;

    const SwiperEl = () => (
        <Swiper autoplay={
            isAutoPlay
                ? {
                    delay: duration * 1000,
                    disableOnInteraction: false,
                }
                : false
        } modules={[Navigation, A11y, ...(isAutoPlay ? [Autoplay] : [])]} spaceBetween={20} navigation pagination={{ clickable: true }} loop={true} breakpoints={{
            0: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            577: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // Small Desktop devices (769px to 1024px)
            769: {
                slidesPerView: slidesView?.desktop,
                spaceBetween: 10
            },
            // Large Desktop devices (1025px and above)
            1025: {
                slidesPerView: slidesView?.desktop,
                spaceBetween: 10
            }
        }}>
            {items?.map((item, index) => (
                <SwiperSlide key={index}>
                    <div className="item">
                        <div className="img">
                            <img src={item?.url} alt={`Logo ${index + 1}`} />
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );

    return <SwiperEl />;
}

export default Slider;
